const checkImgSrcIsGif = src => {
  const updatedSrc = /\.(gif)$/i.test(src) ? `${src}?a=${Math.random()}` : src;
  return updatedSrc;
};

export default checkImgSrcIsGif;
